import { connect } from 'react-redux';
import { reduxForm, getFormValues, isPristine, getFormInitialValues, change } from 'redux-form';
import compose from 'lodash/fp/compose';
import { FORM_NAME_TAX_DEDUCTION_CERT_SEARCH, fetchGroupedPaymentYearsWithoutConfirmed } from 'src/reducers/searchForm';
import { TAX_DEDUCTION_CERT_EDIT_FORM } from 'src/constants/FormNames';
import { getIsLoading, getList } from 'src/reducers/common/listReducer';
import { DEFAULT_PAGING_PER_PAGE } from 'src/Config';
import {
  REDUCER_NAME,
  fetchYearEndReportTaxDeductionCerts,
  downloadTaxDeductionCerts,
  bulkUpdateTaxDeductionCertAdjustments,
  fetchUnconfirmedMonths,
  resetTaxDeductionCertAdjustment
} from 'src/reducers/year_end_reports/yearEndReportTaxDeductionCerts';
import ShowTaxDeductionCertsDataPage from '../ShowTaxDeductionCertsDataPage';

const mapStateToProps = state => ({
  isListLoading: getIsLoading(REDUCER_NAME, state) || false,
  formValues: getFormValues(FORM_NAME_TAX_DEDUCTION_CERT_SEARCH)(state),
  employeePays: getList(REDUCER_NAME, state) || [],
  isEditFormPristine: isPristine(TAX_DEDUCTION_CERT_EDIT_FORM)(state),
  editFormInitialValues: getFormInitialValues(TAX_DEDUCTION_CERT_EDIT_FORM)(state) || {}
});

const mapDispatchToProps = dispatch => ({
  fetchGroupedPaymentYears: () => {
    dispatch(fetchGroupedPaymentYearsWithoutConfirmed());
  },
  fetchYearEndReportTaxDeductionCerts: (formValues, isFetchGrouped) => {
    dispatch(fetchYearEndReportTaxDeductionCerts(formValues, isFetchGrouped));
  },
  downloadTaxDeductionCerts: formValues => {
    dispatch(downloadTaxDeductionCerts(formValues));
  },
  bulkUpdateAdjustments: (year, adjustments) => dispatch(bulkUpdateTaxDeductionCertAdjustments(year, adjustments)),
  fetchUnconfirmedMonths: (year, clientBranchId, employeeIds) => {
    dispatch(fetchUnconfirmedMonths(year, clientBranchId, employeeIds));
  },
  resetAdjustment: (year, employeeId, employeeName) => dispatch(resetTaxDeductionCertAdjustment(year, employeeId, employeeName)),
  changePage: page => dispatch(change(FORM_NAME_TAX_DEDUCTION_CERT_SEARCH, 'page', page))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORM_NAME_TAX_DEDUCTION_CERT_SEARCH,
    enableReinitialize: true,
    initialValues: { page: 1, limit: DEFAULT_PAGING_PER_PAGE }
  })
)(ShowTaxDeductionCertsDataPage);
